import { timeframeHealthOverview } from '@/modules/crypto-assets/services/cryptoAssetsService'
import type { TimeframeHealth, TimeframeHealthOverview } from '@/modules/crypto-assets/services/cryptoAssetsService'
import { fetchHealthSnapshotsLatest } from '@/modules/crypto-assets/services/healthSnapshotService'

let lastAt = 0
let lastData: TimeframeHealthOverview | null = null

// Reduz a janela de cache para refletir mudanças no fechamento de buckets
const TTL_MS = 15_000 // 15s

export async function getHealthOverviewCached(force = false): Promise<TimeframeHealthOverview> {
  const now = Date.now()
  if (!force && lastData && (now - lastAt) < TTL_MS) return lastData
  // Em modo "force", consulta diretamente a visão corrente (sem snapshots) para evitar latência de cron
  if (force) {
    const data = await timeframeHealthOverview()
    lastData = data
    lastAt = now
    return data
  }
  // Caminho normal: tenta snapshots (rápido) e faz fallback para overview direto
  let data: TimeframeHealthOverview | null = null
  try {
    const rows = await fetchHealthSnapshotsLatest()
    if (rows && rows.length) {
      const map: Record<string, { symbol: string; timeframes: any[]; warnings: number }> = {}
      for (const r of rows) {
        const key = r.symbol
        if (!map[key]) map[key] = { symbol: r.symbol, timeframes: [], warnings: 0 }
        if (!map[key].timeframes.find((t) => t.timeframe === r.timeframe)) {
          map[key].timeframes.push({
            timeframe: r.timeframe,
            count: r.count,
            latest: r.latest,
            has500: r.has500,
            stale_seconds: r.stale_seconds,
            gap_count: r.gap_count,
            status: r.status,
          })
          if (String(r.status).toLowerCase() !== 'ok') map[key].warnings++
        }
      }
      data = { results: Object.values(map) as any, generated_at: new Date().toISOString() }
    }
  } catch {}
  if (!data) data = await timeframeHealthOverview()
  lastData = data
  lastAt = now
  return data
}

export function toSymbolMap(ov: TimeframeHealthOverview): Record<string, TimeframeHealth | undefined> {
  const map: Record<string, TimeframeHealth | undefined> = {}
  for (const r of ov.results || []) map[r.symbol] = r
  return map
}

export function invalidateHealthOverview() {
  lastAt = 0
}
